var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.booking)?_c('span',{staticClass:"btn btn-sm",class:_vm.paymentStatusClass},[_vm._v(" "+_vm._s(_vm.$t("booking.paymentStates." + _vm.booking.paymentStatus))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }